import { useMutation, useQuery } from '@tanstack/react-query';
import { downloadUsageCsv, getUsage, getUsageLimits } from './endpointsUsage';
import { qk } from './queryKeys';

/* ---------- Usage and plan (SPEC §18.1) ---------- */

/** The plan and its meters. They move as builds end, so a focus or a minute later refreshes them. */
export const useUsageLimits = (enabled = true) => useQuery({ queryKey: qk.usageLimits, queryFn: getUsageLimits, enabled, staleTime: 30_000, refetchInterval: 60_000 });

/** The usage of one month; the previous month stays on screen while the next one loads. */
export const useUsage = (month: string | undefined, enabled = true) =>
  useQuery({ queryKey: qk.usage(month ?? 'current'), queryFn: () => getUsage(month), enabled, staleTime: 30_000, placeholderData: (previous) => previous });

/** The month's CSV as a blob (the bearer token travels in the header, so the file is fetched, then saved). */
export const useUsageExport = () => useMutation({ mutationFn: (month: string) => downloadUsageCsv(month) });
